<!------------------------------------------------------------------------------
  - Copyright (c) 2019. BMW Group. All rights reserved.
  ----------------------------------------------------------------------------->

<app-generic-modal [primaryActionTitle]="primaryActionTitle"
                   [title]="title"
                   [primaryActionEnabled]="isValid"
                   (primaryActionEvent)="save()"
                   secondaryActionTitle="Discard">
    <div class="business-modal-body">
        <app-input-text #transportServiceNameInput
                        label="Transport service name"
                        placeholder="Please, write a new transport service name"
                        baseCypressTag="business-settings-transport-service-modal-name"
                        [warningLevel]="WarningsEnum.WARNING_SAVE"
                        [maxLength]="100"
                        [validators]="validators.name"
                        [messages]="nameMessages"
                        (inputValueChange)="nameInputChange($event)"></app-input-text>

        <app-input-text #transportServiceCodeInput
                        label="Transport service code"
                        placeholder="Please, write a new transport service code, e.g. EXP"
                        baseCypressTag="business-settings-transport-service-modal-code"
                        [warningLevel]="WarningsEnum.WARNING_SAVE"
                        [maxLength]="3"
                        [validators]="validators.code"
                        [messages]="codeMessages"
                        (inputValueChange)="codeInputChange($event)"></app-input-text>

        <div fieldset id="requires-justification-input-form" class="modal-radio-input">

            <div class="modal-info-label"
                 data-cy="business-settings-transport-service-requires-justification-label">Requires justification?</div>

            <div class="modal-radio-input-option">
                <input type="radio" id="yes" name="requires-justification"
                       (change)="requiresJustificationInputChange(true)"
                       [checked]="$safeNavigationMigration(state?.currentValue?.requiresJustification)"
                       data-cy="business-settings-transport-service-modal-radio-button-yes">
                <label for="yes" class="modal-radio-input-label">Yes</label>
            </div>
            <div class="modal-radio-input-option">
                <input type="radio" id="no" name="requires-justification"
                       (change)="requiresJustificationInputChange(false)"
                       [checked]="!state?.currentValue?.requiresJustification"
                       data-cy="business-settings-transport-service-modal-radio-button-no">
                <label for="no" class="modal-radio-input-label">No</label>
            </div>
        </div>

        <app-active-input [entityName]="ENTITY_NAME" [state]="$safeNavigationMigration(state?.isActive)"
                          (checkState)="setActiveInputState($event)"></app-active-input>
    </div>

</app-generic-modal>
